import React from 'react'
import { Select, Input, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl, getCookie, outputMoney, getCookieNew} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './medical-equipmentn-onhaitao.module.less'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class CooperationPolicy extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      medicalCareOnHtaoData: null
    }
  }

  componentDidMount () {
    this.setState({
      medicalCareOnHtaoData: JSON.parse(sessionStorage.getItem('medicalCareOnHtaoData'))
    }, () => {
    })
  }

// 获取返利乘车、毛利率、毛利额的值
publicDealCost=async (param) => {
  let {medicalCareOnHtaoData} = this.state
  let res = await ajaxApi({
    url: common.scpUrl + 'item/deal-cost',
    // url:'http://192.168.10.220:8120/item/deal-cost',
    params: param
  })
  if (res.status === 200) {
    medicalCareOnHtaoData.item_info.rebate_cost = res.data.rebate_cost
    medicalCareOnHtaoData.item_info.gross_money = res.data.gross_money
    medicalCareOnHtaoData.item_info.gross_rate = res.data.gross_rate
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }
}

  // 获取input的值
  handleChangeInput=(e, name) => {
    let {medicalCareOnHtaoData} = this.state
    medicalCareOnHtaoData.item_info[name] = e.target.value

    if (medicalCareOnHtaoData.item_info.rebate_type !== '' && medicalCareOnHtaoData.item_info.rebate_point !== '' && medicalCareOnHtaoData.item_info.purchase_price !== '' && medicalCareOnHtaoData.item_info.promotion_price !== '' && medicalCareOnHtaoData.item_info.rebate_note !== '') {
      let _param = {
        rebate_type: medicalCareOnHtaoData.item_info.rebate_type,
        rebate_point: medicalCareOnHtaoData.item_info.rebate_point,
        purchase_price: medicalCareOnHtaoData.item_info.purchase_price,
        promotion_price: medicalCareOnHtaoData.item_info.promotion_price,
        rebate_note: medicalCareOnHtaoData.item_info.rebate_note
      }

      this.publicDealCost(_param)
    }

    if (medicalCareOnHtaoData.item_info.is_rebate === 0) {
      if (medicalCareOnHtaoData.item_info.promotion_price !== '' && medicalCareOnHtaoData.item_info.purchase_price !== '') {
        medicalCareOnHtaoData.item_info.gross_money = (medicalCareOnHtaoData.item_info.promotion_price * 1) - (medicalCareOnHtaoData.item_info.purchase_price * 1)
        medicalCareOnHtaoData.item_info.gross_rate = ((medicalCareOnHtaoData.item_info.promotion_price * 1) - (medicalCareOnHtaoData.item_info.purchase_price * 1)) / medicalCareOnHtaoData.item_info.promotion_price * 1
      }
      if (name === 'purchase_price' || name === 'rebate_cost') {
        medicalCareOnHtaoData.item_info.purchase_price = e.target.value
        medicalCareOnHtaoData.item_info.rebate_cost = e.target.value
      }
    }
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // 获取下拉框的值
  handelChangeSource=(e, name) => {
    let {medicalCareOnHtaoData} = this.state
    medicalCareOnHtaoData.item_info[name] = e

    if (medicalCareOnHtaoData.item_info.rebate_type !== '' && medicalCareOnHtaoData.item_info.rebate_point !== '' && medicalCareOnHtaoData.item_info.purchase_price !== '' && medicalCareOnHtaoData.item_info.promotion_price !== '' && medicalCareOnHtaoData.item_info.rebate_note !== '') {
      let _param = {
        rebate_type: medicalCareOnHtaoData.item_info.rebate_type,
        rebate_point: medicalCareOnHtaoData.item_info.rebate_point,
        purchase_price: medicalCareOnHtaoData.item_info.purchase_price,
        promotion_price: medicalCareOnHtaoData.item_info.promotion_price,
        rebate_note: medicalCareOnHtaoData.item_info.rebate_note
      }

      this.publicDealCost(_param)
    }

    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // 回到上一步
  handleBack=() => {
    this.props.getCurrent(1)
    sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
  }

  // 提交
  handleSubmit = async () => {
    let {medicalCareOnHtaoData} = this.state
    let _flagExtend = true
    let _flagSku = true
    // if (medicalCareOnHtaoData.item_info.input_type === 'complete') {
    for (let item in medicalCareOnHtaoData.item_info) {
      if (medicalCareOnHtaoData.item_info[item] === '' || medicalCareOnHtaoData.item_info[item] === null) {
        if (item === 'item_name') {
          message.warning('请输入商品名称', 1.5)
          return
        } else if (item === 'brand_id') {
          message.warning('请输入商品牌', 1.5)
          return
        } else if (item === 'common_name') {
          message.warning('请输入通用名称', 1.5)
          return
        } else if (item === 'decription') {
          message.warning('请输入商品描述', 1.5)
          return
        } else if (item === 'price_unit') {
          message.warning('请输入计价单位', 1.5)
          return
        } else if (item === 'is_customed') {
          message.warning('请选择是否散光片', 1.5)
          return
        } else if (item === 'operation') {
          message.warning('请选择经营属性', 1.5)
          return
        } else if (item === 'is_qualification') {
          message.warning('请选择资质控件', 1.5)
          return
        } else if (item === 'item_useful_life') {
          message.warning('请输入有效期', 1.5)
          return
        } else if (item === 'packing_specification') {
          message.warning('请输入包装规格', 1.5)
          return
        } else if (item === 'regist_number') {
          message.warning('请输入产品注册证号', 1.5)
          return
        } else if (item === 'element') {
          message.warning('请输入成分', 1.5)
          return
        } else if (item === 'regist_useful_life') {
          message.warning('请输入注册证有效期', 1.5)
          return
        } else if (item === 'create_company') {
          message.warning('请输入生产企业', 1.5)
          return
        } else if (item === 'origin_place') {
          message.warning('请输入产地', 1.5)
          return
        } else if (item === 'main_function') {
          message.warning('请输入主要功能', 1.5)
          return
        } else if (item === 'storage_request') {
          message.warning('请输入存储要求', 1.5)
          return
        } else if (item === 'period_day') {
          message.warning('请输入账期', 1.5)
          return
        } else if (item === 'distribution_money') {
          message.warning('请输入铺货金额', 1.5)
          return
        } else if (item === 'is_rebate') {
          message.warning('请选择有无返利', 1.5)
          return
        } else if (item === 'purchase_price') {
          message.warning('请输入结算价', 1.5)
          return
        } else if (item === 'promotion_price') {
          message.warning('请输入促销价', 1.5)
          return
        } else if (item === 'order_cycle') {
          message.warning('请输入供应商订货周期', 1.5)
          return
        } else if (item === 'after_sale_problem') {
          message.warning('请选择售后问题', 1.5)
          return
        } else if (item === 'arrive_cycle') {
          message.warning('请选择采购到货周期', 1.5)
          return
        } else if (item === 'is_one_sale') {
          message.warning('请选择是否独家销售', 1.5)
          return
        } else if (item === 'promote_charge') {
          message.warning('请输入市场推广费用', 1.5)
          return
        }
      }
    }

    //   if(medicalCareOnHtaoData.item_info.categor_name === '隐形眼镜' || medicalCareOnHtaoData.item_info.categor_name === '液眼镜' || medicalCareOnHtaoData.item_info.categor_name === '润眼液' || medicalCareOnHtaoData.item_info.categor_name === '镜架夹片' || medicalCareOnHtaoData.item_info.categor_name === '镜片' || medicalCareOnHtaoData.item_info.categor_name === '洗眼液'){
    //     if (medicalCareOnHtaoData.item_info.spec_type === '' || medicalCareOnHtaoData.item_info.spec_type === null) {
    //      message.warning('请输入规格型号', 1.5)
    //      return
    //    }
    //  }

    if (medicalCareOnHtaoData.item_info.charge_level === 'medical') {
      if (medicalCareOnHtaoData.item_info.spec_type === '' || medicalCareOnHtaoData.item_info.spec_type === null) {
        message.warning('请输入规格型号', 1.5)
        return
      }
    }

    if (medicalCareOnHtaoData.item_info.is_rebate === 1) {
      if (medicalCareOnHtaoData.item_info.rebate_type === '' || medicalCareOnHtaoData.item_info.rebate_type === null) {
        message.warning('请选择返利方式', 1.5)
        return
      } else if (medicalCareOnHtaoData.item_info.rebate_point === '' || medicalCareOnHtaoData.item_info.rebate_point === null) {
        message.warning('请输入返利点数', 1.5)
        return
      } else if (medicalCareOnHtaoData.item_info.rebate_base === '' || medicalCareOnHtaoData.item_info.rebate_base === null) {
        message.warning('请选择返利基数', 1.5)
        return
      } else if (medicalCareOnHtaoData.item_info.rebate_note === '' || medicalCareOnHtaoData.item_info.rebate_note === null) {
        message.warning('请选择返利产生节点', 1.5)
        return
      }
    }

    _lodash.forEach(medicalCareOnHtaoData.extend_propertys, (item, index) => {
      if (item.is_required === 1) {
        if (item.extend_value === '' || item.extend_value === null) {
          message.warning('请输入' + item.property_name, 1.5)
          _flagExtend = false
        }
      }
    })

    _lodash.forEach(medicalCareOnHtaoData.sku_propertys, (item, index) => {
      if (item.is_required === 1) {
        let isRequired = true
        item.sku_value.map((item, index) => {
          if (item === '') {
            isRequired = false
            _flagSku = false
          }
        })
        if (!isRequired) {
          message.warning('请输入' + item.property_name, 1.5)
        }
      }
    })

    if (_flagSku === false || _flagExtend === false) {
      return false
    }

    medicalCareOnHtaoData.item_info.creater = getCookieNew('supplier_code') || null
    medicalCareOnHtaoData.item_info.create_ch = getCookieNew('supplier_company_name') ||''
    sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(medicalCareOnHtaoData))
    let _url = ''
    if (getParmUrl('type')) {
      _url = common.scpUrl + 'item/update'
      medicalCareOnHtaoData.action = getParmUrl('type')
    } else {
      _url = common.scpUrl + 'item/add'
    }
    let res = await ajaxApi({
      url: _url,
      params: medicalCareOnHtaoData
    })
    if (res.status === 200) {
      this.props.history.push({pathname: '/main/commoditymanagement/commoditymanagementlist/commodity-management-list'})
    }
    // }
  }

  render () {
    let {medicalCareOnHtaoData} = this.state
    return (
      <div>
        <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
          <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', paddingLeft: '13%' }}>
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>账期：</span>
                <Input onKeyDown={this.onKeyup} addonAfter='天' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.period_day : ''} placeholder='请输入' name='period_day' onChange={(e) => this.handleChangeInput(e, 'period_day')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>铺货金额：</span>
                <Input onKeyDown={this.onKeyup} addonBefore='¥' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.distribution_money : ''} placeholder='请输入' name='distribution_money' onChange={(e) => this.handleChangeInput(e, 'distribution_money')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>有无返利：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_rebate : ''}
                  onChange={(e) => this.handelChangeSource(e, 'is_rebate')}
                >
                  <Option key={0} name='is_rebate' value={1}>有</Option>
                  <Option key={1} name='is_rebate' value={0}>无</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利方式：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  disabled={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_rebate ? medicalCareOnHtaoData.item_info.is_rebate === 0 : medicalCareOnHtaoData.item_info.is_rebate === 0 : false}
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.rebate_type : ''}
                  onChange={(e) => this.handelChangeSource(e, 'rebate_type')}
                >
                  <Option key={0} name='rebate_type' value='reduce'>减账</Option>
                  <Option key={1} name='rebate_type' value='goods'>货返</Option>
                  <Option key={2} name='rebate_type' value='cash'>现金打款</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利点数：</span>
                <Input disabled={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_rebate ? medicalCareOnHtaoData.item_info.is_rebate === 0 : medicalCareOnHtaoData.item_info.is_rebate === 0 : false} onKeyDown={this.onKeyup} addonAfter='%' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.rebate_point : ''} placeholder='请输入' name='rebate_point' onChange={(e) => this.handleChangeInput(e, 'rebate_point')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利基数：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  disabled={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_rebate ? medicalCareOnHtaoData.item_info.is_rebate === 0 : medicalCareOnHtaoData.item_info.is_rebate === 0 : false}
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.rebate_base : ''}
                  onChange={(e) => this.handelChangeSource(e, 'rebate_base')}
                >
                  <Option key={0} name='rebate_base' value=''>请选择</Option>
                  <Option key={1} name='rebate_base' value='no_tax'>未税</Option>
                  <Option key={2} name='rebate_base' value='tax'>含税</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>结算价：</span>
                <Input onKeyDown={this.onKeyup} addonBefore='¥' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.purchase_price : ''} placeholder='请输入' name='purchase_price' onChange={(e) => this.handleChangeInput(e, 'purchase_price')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>促销价：</span>
                <Input onKeyDown={this.onKeyup} addonBefore='¥' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.promotion_price : ''} placeholder='请输入' name='promotion_price' onChange={(e) => this.handleChangeInput(e, 'promotion_price')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>毛利率：</span>
                <Input onKeyDown={this.onKeyup} disabled addonAfter='%' placeholder='请输入' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.gross_rate ? outputMoney(medicalCareOnHtaoData.item_info.gross_rate * 10000 / 100) : '' : ''} name='gross_rate' onChange={(e) => this.handleChangeInput(e, 'gross_rate')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>毛利额：</span>
                <Input onKeyDown={this.onKeyup} disabled placeholder='请输入' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.gross_money : ''} name='gross_money' onChange={(e) => this.handleChangeInput(e, 'gross_money')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>返利成本：</span>
                <Input onKeyDown={this.onKeyup} placeholder='请输入' disabled value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.rebate_cost : ''} name='rebate_cost' onChange={(e) => this.handleChangeInput(e, 'rebate_cost')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>供应商订货周期：</span>
                <Input onKeyDown={this.onKeyup} addonAfter='天' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.order_cycle : ''} placeholder='请输入' name='order_cycle' onChange={(e) => this.handleChangeInput(e, 'order_cycle')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>售后问题：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.after_sale_problem : ''}
                  onChange={(e) => this.handelChangeSource(e, 'after_sale_problem')}
                >
                  <Option key={0} name='after_sale_problem' value='add_goods'>补发</Option>
                  <Option key={1} name='after_sale_problem' value='return_goods'>退货</Option>
                  <Option key={2} name='after_sale_problem' value='return_money'>退款</Option>
                  <Option key={3} name='after_sale_problem' value='replace_goods'>换货</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>采购到货周期：</span>
                <Input onKeyDown={this.onKeyup} addonAfter='天' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.arrive_cycle : ''} placeholder='请输入' name='arrive_cycle' onChange={(e) => this.handleChangeInput(e, 'arrive_cycle')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>是否独家销售：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_one_sale : ''}
                  onChange={(e) => this.handelChangeSource(e, 'is_one_sale')}
                >
                  <Option key={0} name='is_one_sale' value={1}>是</Option>
                  <Option key={1} name='is_one_sale' value={0}>否</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>市场推广费用：</span>
                <Input onKeyDown={this.onKeyup} addonAfter='¥' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.promote_charge : ''} placeholder='请输入' name='promote_charge' onChange={(e) => this.handleChangeInput(e, 'promote_charge')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利产生节点：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  disabled={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_rebate ? medicalCareOnHtaoData.item_info.is_rebate === 0 : medicalCareOnHtaoData.item_info.is_rebate === 0 : false}
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.rebate_note : ''}
                  onChange={(e) => this.handelChangeSource(e, 'rebate_note')}
                >
                  <Option key={0} name='rebate_note' value='stock'>进货</Option>
                  <Option key={1} name='rebate_note' value='return_money'>回款</Option>
                </Select>
              </section>
            </div>

            <div style={{width: '100%', marginBottom: '24px', marginTop: '56px', textAlign: 'center'}}>
              <Button type='' onClick={this.handleBack}>上一步</Button>
              <Button type='' style={{margin: '0px 8px'}} onClick={this.handleSubmit}>提交</Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default CooperationPolicy



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addcompleteinformation/medicalequipmentnonhaitao/cooperation-policy.js